import { FileSearch } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@design-system';
import { CONSUMER_POLICY_REVIEW_NAMES } from '@shared/consumerPlan';
import { usePolicyReviewInProgress } from '../hooks/use-policy-review';

/** Reminds a consumer exploring coverage that their policy review is still with our team. */
export function PolicyReviewInProgressNotice({ clientId }: { clientId: string }) {
  const review = usePolicyReviewInProgress(clientId);
  if (!review) return null;

  return (
    <Alert variant="info" data-testid="consumer-review-in-progress">
      <FileSearch />
      <AlertTitle>Your {CONSUMER_POLICY_REVIEW_NAMES[review.reviewType].toLowerCase()} is in progress</AlertTitle>
      <AlertDescription>We’ll email your results, usually within 24–48 hours of receiving complete documents.</AlertDescription>
    </Alert>
  );
}
